module.exports = __webpack_public_path__ + "static/media/warning.f6060083.svg";